<template>
    <div class="factory-research-version">
        <el-row class="factory-research-fault-title">
            <el-col :span="3">
                <span class="h3">版本库</span>
            </el-col>
            <el-col :span="6" :offset="13">
                <div class="factory-research-fault-title-filter">
                    <span class="label">条件搜索：</span>
                    <el-select placeholder="选取产品类型" v-model="pagination.productUuid" @change="loadProductVersion">
                        <el-option :value="product.uuid" :label="product.name" v-for="product in factoryProductNames"
                                   :key="product.uuid"/>
                    </el-select>
                </div>
            </el-col>
            <el-col :span="2">
                <span class="btn-add" @click="handleAddVersion"> <i class="iconfont icon-tianjia1"></i> 新增版本</span>
            </el-col>
        </el-row>

        <div class="factory-research-fault-data-list">
            <el-table :data="versions">
                <el-table-column label="序号" align="center" prop="uuid"></el-table-column>
                <el-table-column label="版本号" align="center">
                    <template slot-scope="scope">
                        {{scope.row.version}} <span v-if="scope.row.isDefault" class="default">默认</span>
                    </template>
                </el-table-column>
                <el-table-column label="简要说明" align="center" prop="description"></el-table-column>
                <el-table-column label="适用产品" align="center" prop="productName">

                </el-table-column>
                <el-table-column :label="$t('cao_zuo')" align="center" prop="name">
                    <template slot-scope="scope">
                        <span @click="handleVersionDefault(scope.row)"
                              class="research-fault-edit" v-if="!scope.row.isDefault">设为默认产品</span>
                        <span @click="handleDelete(scope.row, scope.$index)" class="research-fault-delete">{{$t('shan_chu')}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                    @current-change="handleCurrentChange"
                    class="pagination"
                    :current-page="pagination.curPage"
                    :page-size="pagination.limit"
                    layout="total, prev, pager, next, jumper"
                    :total="pagination.total">
            </el-pagination>
        </div>


        <c-dialog class="dialog" :visible.sync="addVersionVisible" :width="'50rem'" :height="'37.5rem'" title="上传版本">
            <div class="version-dialog">
                <upload :url.sync="version.upgrade"></upload>
                <div class="version-dialog-body clearfix">
                    <el-form class="base-info" label-width="100px">
                        <el-form-item label="主版本">
                            <el-input v-model="version.mainVersion" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="软件版本">
                            <el-input v-model="version.softVersion" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="功能版本">
                            <el-input v-model="version.functionVersion" type="number"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-form class="ctrl-info" label-width="100px">
                        <el-form-item label="适用产品">
                            <el-select placeholder="选取产品类型" v-model="version.productUuid">
                                <el-option :value="product.uuid" :label="product.name"
                                           v-for="(product, index) in factoryProductNames"
                                           :key="index"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="默认版本">
                            <el-switch v-model="version.isDefault"
                                       active-value="1"
                                       inactive-value="0">
                            </el-switch>
                        </el-form-item>
                    </el-form>
                </div>
                <el-form class="ctrl-info" label-width="100px">
                    <el-form-item label="版本说明">
                        <el-input v-model="version.description" type="textarea" :rows="3"></el-input>
                    </el-form-item>
                </el-form>
                <div class="dialog-commit-btn">
                    <el-button class="success" plain @click="versionCreate">{{$t('ti_jiao')}}</el-button>
                </div>
            </div>

        </c-dialog>

    </div>

</template>

<script>
    import CDialog from '@/components/Dialog'
    import Upload from '@/components/Upload'
    import {
        versionUnion,
        versionCreate,
        versionDefault,
        versionDelete,
        versionList
    } from '@/api/factory/research/version';

    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: '',
        components: {
            Upload,
            CDialog
        },
        mounted: function () {
            this.loadProductNames()
            this.loadVersion()
        },
        computed: {
            ...mapGetters(['factoryProductNames'])
        },
        data: function () {
            return {
                versions: [],
                addVersionVisible: false,
                pagination: {
                    productUuid: '',
                    start: 0,
                    curPage: 1,
                    limit: 10,
                    total: 0,
                },
                version: {
                    productUuid: '',
                    productInfo: '',
                    mainVersion: 0,
                    softVersion: 0,
                    functionVersion: 0,
                    isDefault: "0",
                    description: '',
                    upgrade: ''
                },
            }
        },
        filters: {
            faultLevel (type){
                switch (type) {
                    case 0:
                        return `普通通知`
                    case 1:
                        return `媒体通讯通知`
                    case 2:
                        return `短信通知`
                    case 3:
                        return `语音电话通知`
                    case 4:
                        return `强制通知`
                }
                return `未知通知`
            }
        },
        methods: {
            ...mapActions(["loadProductNames"]),
            handleAddVersion() {
                this.version = {
                    productUuid: '',
                    productInfo: '',
                    mainVersion: 0,
                    softVersion: 0,
                    functionVersion: 0,
                    isDefault: "0",
                    description: '',
                    upgrade: 'test'
                }
                this.addVersionVisible = true
            },

            handleVersionDefault(version) {
                versionDefault(version.uuid).then(res => {
                    this.loadVersion()
                })
            },

            handleDelete(version) {
                this.$confirm('此操作将删除指定版本, 是否继续?', this.$t('ti_shi'), {
                    confirmButtonText: this.$t('que_ding'),
                    cancelButtonText: this.$t('qu_xiao'),
                    type: 'warning'
                }).then(() => {
                    versionDelete(version.uuid).then(res => {
                        this.loadVersion()
                    })
                }).catch(() => {

                })

            },
            loadProductVersion (){
                this.pagination.start = 0
                this.pagination.curPage = 1
                this.loadVersion()
            },

            loadVersion (){
                let vue = this
                versionUnion(vue.pagination.productUuid).then(res => {
                    vue.versions = res.data.list || []
                    vue.pagination.total = parseInt(res.data.total)
                })
            },
            handleCurrentChange(value){
                this.pagination.curPage = value
                this.pagination.start = (value - 1) * this.pagination.limit
                versionList(this.pagination).then(res => {
                    this.versions = res.data
                })
            },
            versionCreate () {
                this.version.version = `${this.version.mainVersion}.${this.version.softVersion}.${this.version.functionVersion}`
                this.version.isDefault = parseInt(this.version.isDefault)
                if (this.version.mainVersion === 0 &&
                    this.version.softVersion === 0 &&
                    this.version.functionVersion === 0) {
                    this.$message.error('版本号至少一个不为0')
                    return
                }
                if (this.version.productUuid === '') {
                    this.$message.error('请选取对应的产品')
                    return
                }

                if (this.version.upgrade === '') {
                    this.$message.error('请上传对应版本文件')
                    return
                }
                let vue = this
                versionCreate(this.version).then(res => {
                    vue.version.uuid = res.data
                    vue.addVersionVisible = false
                    vue.loadVersion()
                })
            },
            versionUpdate () {
                this.version.mainVersion = parseInt(this.version.mainVersion)
                this.version.softVersion = parseInt(this.version.softVersion)
                this.version.functionVersion = parseInt(this.version.functionVersion)
                this.version.isBate = parseInt(this.version.isBate)
                this.version.isDefault = parseInt(this.version.isDefault)
                if (this.version.mainVersion === 0 &&
                    this.version.softVersion === 0 &&
                    this.version.functionVersion === 0) {
                    this.$message.error('版本号至少一个不为0')
                    return
                }
                if (this.version.upgrade === '') {
                    this.$message.error('请上传对应版本文件')
                    return
                }
                let vue = this
                versionUpdate(this.version).then(res => {
                    if (vue.version.isBate === 0) {
                        vue.version.publishAt = new Date() / 1000
                    }
                    vue.editVersionVisible = false
                })
            }
        },
    }
</script>

<style lang="scss">
    .factory-research-version {
        padding: $padding $t-padding;
        display: flex;
        flex-direction: column;
        .factory-research-fault-title {
            margin-bottom: $padding;
            .factory-research-fault-title-filter {
                display: flex;
                justify-content: center;
                align-items: center;
                .label {
                    display: inline-block;
                    width: 5rem;
                    font-size: .6rem;
                    color: $f_sec_color;
                    text-align: right;
                }
            }
            .el-input {
                .el-input__inner {
                    height: 24px;
                    line-height: 24px;
                }
                .el-input__icon {
                    line-height: 24px;
                }
            }
            .btn-add {
                margin-left: $padding-5;
                color: $f_color;
                font-size: .6rem;
                padding: $padding-3;
                border-radius: .3rem;
                cursor: pointer;
            }
            .btn-add:hover {
                background-color: $bg_six_color;
                font-weight: $w1;
            }
        }

        .factory-research-fault-data-list {
            flex: 1;
            border-radius: .5rem;
            // background-color: $bg_sec_color;
            padding: $padding;
            .research-fault-edit, .research-fault-delete {
                cursor: pointer;
                display: inline-block;
                margin-right: $padding;
            }
            .research-fault-edit {
                color: $btn_color;
            }
            .research-fault-delete {
                color: $btn_sec_color;
            }

            .pagination {
                margin-top: $padding;
            }

            .default {
                font-size: .6rem;
                background-color: $f_50_color;
                padding: 2px 4px;
                border-radius: 2px;
            }
        }

        .dialog {

            .version-dialog {
                padding: 0 $padding;
                .el-form-item__label {
                    color: $f_sec_color;
                }
                .el-textarea__inner, .el-input__inner {
                    border-color: $bg_999_color;
                    color: $f_th_color;
                }

                .el-upload-dragger {
                    background-color: transparent;
                }

                .el-textarea__inner {
                    font-size: .6rem;
                }

                .el-button {
                    color: $f_color;
                }
                .version-dialog-body {
                    padding: 0 $padding;
                    .el-input, .el-textarea {
                        width: 218px;
                    }

                    .base-info, .ctrl-info {
                        float: left;
                        width: 50%;
                    }
                }
                .hidden {
                    .el-upload-dragger {
                        display: none;
                    }
                }
                .el-upload {
                    width: 100%;
                    .el-upload-dragger {
                        width: 100%;
                    }
                }
                .dialog-commit-btn {
                    text-align: center;
                }
            }
        }
    }

</style>
